import React from "react";
import { Users, UserPlus, User, Shield, Clock, Trash2 } from "lucide-react";

export default function StaffTab({ loading, staffList, user, dayNames, onAddStaff, onDeleteStaff }) {
  return (
    <div>
      <div className="admin-section-header">
        <h2 className="section-title" style={{ marginBottom: 0 }}>Çalışan Yönetimi</h2>
        <button onClick={onAddStaff} className="btn-add">
          <UserPlus />
          Yeni Çalışan
        </button>
      </div>

      {loading ? (
        <div className="admin-empty">
          <Users />
          <p>Çalışanlar yükleniyor...</p>
        </div>
      ) : staffList.length === 0 ? (
        <div className="admin-empty">
          <Users />
          <p>Henüz bir çalışan eklenmemiş.</p>
        </div>
      ) : (
        <div>
          {staffList.map((member) => (
            <div key={member.id} className="admin-staff-item">
              <div className="admin-staff-info">
                <div className={`admin-staff-avatar${member.role === "admin" ? " is-admin" : ""}`}>
                  <User />
                </div>
                <div>
                  <div className="admin-staff-name">{member.fullName}</div>
                  <div className="admin-staff-meta">
                    <span className={`role-badge small ${member.role}`}>
                      {member.role === "admin" && <Shield />}
                      {member.role === "admin" ? "Yönetici" : "Personel"}
                    </span>
                    <span className="staff-hours-badge">
                      <Clock />
                      {member.workingHours.start} - {member.workingHours.end}
                    </span>
                    {member.closedDays.length > 0 && (
                      <span className="staff-closed-badge">
                        {member.closedDays.map((d) => dayNames[d]?.substring(0, 3)).join(", ")} kapalı
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="admin-service-actions">
                {member.id !== user.id && (
                  <button
                    onClick={() => onDeleteStaff(member.id)}
                    className="btn-icon danger"
                    title="Çalışanı Sil"
                  >
                    <Trash2 />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
